<template>
  <div class="candidate-list-item flex">
    <candidate-portrait
      :candidate="candidate"
      :show-position="false"
      :small="false"
      style="top: 0.27rem;"
    />
    <div class="flex-1 text-left mx-2">
      <p class="text-chplus-regular font-bold">
        {{ candidate.firstName }} {{ candidate.lastName }}
      </p>
      <p class="text-chplus-regular">{{ candidate.birthYear }}</p>
      <list-place
        :key="index"
        v-for="(listPlace, index) of listPlaces"
        :list-place="listPlace"
        class="text-chplus-regular"
      />
      <p class="text-chplus-regular">{{ candidate.city }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CandidatePortrait from "./CandidatePortrait";
import ListPlace from "./ListPlace";

/**
 * Represents a candidate in the election list view. Shows additional info next to the candidate portrait.
 */
export default {
  name: "CandidateListItem",
  components: {
    ListPlace,
    CandidatePortrait
  },
  props: {
    candidateId: {
      type: Number,
      required: true
    },
    /**
     * @var Provides context for which list this candidate is looking at to check their seat count. Takes the dream
     * team if null.
     */
    activeList: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters("candidate", { getCandidate: "candidate" }),
    candidate() {
      return this.getCandidate(this.candidateId);
    },
    teamPlaces() {
      let list = this.activeList ?? this.chosenList;
      return list
        ? list.candidates.filter(c => c.id === this.candidateId).length
        : 0;
    },
    listPlaces() {
      const allListPlaces = this.candidate.listPlaces;
      const getList = this.$store.getters["list/list"];
      return allListPlaces.filter(
        p => p.listId == null || p.listId === 0 || getList(p.listId) != null
      );
    }
  }
};
</script>

<style scoped>
.candidate-list-item {
  color: var(--color-regular);
}
.candidate-list-item p,
.candidate-list-item span {
  line-height: 1.2em;
}
</style>
